module.exports = __webpack_public_path__ + "static/media/YM80_9.8160445c.jpg";